import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSignaturePad from 'vue-signature-pad'
import Rollbar from 'rollbar'
import config from "./config";

if(config.rollbar.enabled){
  Vue.prototype.$rollbar = new Rollbar({
    accessToken: config.rollbar.accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: config.environment,
    reportLevel: 'error'
  });

  Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}

Vue.use(VueSignaturePad)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
